//import Libraries
import React from 'react';

//import Components
import {FormGroup, Col, Label, Input} from 'reactstrap';

//import Styles


const articleSelectFormGroup = (props) => {
    console.log(props.values);

    return (
        <FormGroup 
            row 
            disabled={props.disabled}
        >
            <Label sm={1} size="sm"><b>{props.label}</b></Label>
            <Col sm={10}>
                <Input
                    type='select'
                    name={props.name}
                    onChange={props.onChange}
                    value={props.value}
                    bsSize="sm"
                >
                    {
                        props.options.map((option, index) => {
                            return <option value={props.values[index]}>{option}</option>
                        })
                    }
                </Input>
            </Col>
        </FormGroup>
    );
}
export default articleSelectFormGroup;

articleSelectFormGroup.defaultProps = {
    disabled : false
}



// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/ArticleManager/Elements/ArticleSelectFormGroup.js